import React from 'react';
import '../styles/roboticsProduct.css'
import AnimationBox from '../animationBox';
import AnimatedArrowButton from './AnimatedArrowButton';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import product1 from '../assets/p5.png';
import product2 from '../assets/p6.png';
import product3 from '../assets/p7.png';
import product4 from '../assets/p8.png';


const Products2= () => {

    const sliderSettings = {
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        arrows:false,
        pauseOnHover: true,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      };

    const cards = [
        { name: 'Articulated RobotIRB 1300', company: "" , image:product1  , Arms:"1" , payload:'7-111 Kg' , reach:'0.9-1.4m'},
        { name: 'Dual-arm YuMi IRB 14000', company: "" , image:product3  , Arms:"2" , payload:'0.5 Kg' , reach:'0.559m'},
        { name: 'Single-arm YuMi IRB 14050', company: "" , image:product2 , Arms:"1" , payload:'0.5 Kg' , reach:'0.559m'},
        { name: 'Articulated Robot IRB 1100', company: "" , image:product4  , Arms:"1" , payload:'4 Kg' , reach:'0.475-0.58m'}, 
        
      ];

    return(<div className='roboticsproduct mt-5 pb-4' style={{height:'auto'}}>

        
            <div className='roboticsproduct-inner' >
            
            <div className='myservices' style={{display:'flex',padding:'25px',gap:'10px',paddingTop:"2rem", width:'100%'}}>
                        
                        <div className='services-msg' style={{textAlign:'left', width:'100%'}}>
                            <div style={{display:'flex' , alignItems:'start', justifyContent:'space-between', width:'100%'}}><h1 style={{fontWeight:"600"}}>ABB ROBOTS</h1> <div className='button1'> <AnimatedArrowButton  text="Learn More" link="https://webshop.robotics.abb.com/gl/robots.html"   /></div> </div>
                            <p style={{color:'white', fontSize:"14px"}}>Flexible robot used for arc welding, material handling, and
                            machine tending.</p>
                            <div className='button2'> <AnimatedArrowButton  text="Learn More" link="https://webshop.robotics.abb.com/gl/robots.html"   /></div> 
                        </div>
            </div>
            <hr></hr>
            <div style={{  maxWidth: "90%", margin: "auto" }}>
      <Slider {...sliderSettings}>
        {cards.map((card) => (
          <div key={card.id} style={{ padding: "10px"}}>
            <div
              style={{
                height: "22rem",
                backgroundColor: "#0C0A00",
                border:'1px solid #383838',
                display: "flex",
                alignItems: "center",
                justifyContent: "start",
                borderRadius: "10px",
                marginLeft:"10px",
                marginRight:"10px",
                padding:'1rem',
                flexDirection:'column',
                textAlign:'left'
              }}
              className='product-card'
            >
              <div style={{height:'50%',width:'100%', overflow:'hidden'}}>
                <img src={card.image} style={{objectFit:'contain',width:'100%', height:'100%'}}></img>
                

              </div>
              <h5 style={{width:'100%',marginTop:'1rem'}}>{card.name}</h5>
            <p style={{width:'100%', fontSize:'0.7rem', color:'white', borderBottom:"1px solid #2F2F2F" ,paddingBottom:'0.7rem',marginBottom:'0.3rem'}}>{card.company}</p>
            <div style={{display:'flex', justifyContent:'space-between' , alignItems:'start', width:'100%' , paddingBottom:'0.1rem', borderBottom:"1px solid #2F2F2F",color:"#FFFFFF",fontSize:'0.8rem'}}><p>Arms</p><p>{card.Arms}</p></div>
            <div style={{display:'flex', justifyContent:'space-between' , alignItems:'start', width:'100%' , paddingBottom:'0.1rem', borderBottom:"1px solid #2F2F2F",color:"#FFFFFF",fontSize:'0.8rem'}}><p>Payload</p><p>{card.payload}</p></div>
            <div style={{display:'flex', justifyContent:'space-between' , alignItems:'start', width:'100%' , paddingBottom:'0.1rem', color:"#FFFFFF",fontSize:'0.8rem'}}><p>Reach</p><p>{card.reach}</p></div>

            </div>
            
          </div>
        ))}
      </Slider>
    </div>
            

            </div>
        
    

    </div>);

}

export default Products2;